import { TextualSeparatorDataType } from "../../interfaces/textualSeparator/TextualSeparator.type";
import styles from "./TextualSeparator.module.css";
export default function TextualSeparator({
  item,
}: {
  item: TextualSeparatorDataType;
}) {
  const style = {
    color: item?.textColor,
    "--lineColor": item?.lineColor,
  } as React.CSSProperties;
  return (
    <span
      className={`vas-fs-6 vas-d-block ${styles.lined_text} ${styles.line_before_text} ${styles.line_after_text} vas-fw-normal vas-w-100`}
      style={style}
    >
      {item?.text ?? ""}
    </span>
  );
}
